module.exports = __webpack_public_path__ + "static/media/ic-profile.bcc1de9a.svg";